<app-table-form-container
	[loading]="loading()"
	[showForm]="isFormShowing()"
	modelName="Client"
	(onShowForm)="onShowForm()"
	(onHideForm)="onHideForm()"
>
	<ng-template #tableTemplate>
		<app-cms-table
			[tableKey]="'client-list'"
			[loading]="loading()"
			[rows]="clients()"
			[columns]="columns()"
			[selectedUuid]="editClient()?.uuid"
			(onSelect)="select($event)"
			(onCopy)="copy($event)"
			(onCopyBulk)="copyBulk($event)"
			(onEdit)="edit($event)"
			(onDelete)="delete$($event)"
		>
			<!-- Header templates (defines order/keys) -->
			<ng-template appHeaderColumn="clientName">Client</ng-template>

			<!-- Cell templates (matched by key; use {{ row.name }} etc.) -->
			<ng-template appRowColumn="clientName" let-row>
				<div class="name-column clickable">
					{{ row.active_text.name }}
				</div>
			</ng-template>
		</app-cms-table>
	</ng-template>

	<ng-template #formTemplate>
		<nz-card>
			<app-language-selector (onChange)="onEditLanguageChange($event)"></app-language-selector>
			<app-client-form
				[client]="editClient()"
				[editLanguage]="editLanguage()"
				(onSubmit)="onClientFormSubmit$($event)"
			></app-client-form>
		</nz-card>
	</ng-template>
</app-table-form-container>
